var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Hero'),_c('Lead'),_c('Services'),_c('Clients',{attrs:{"header":"Our work is being touched by millions of users. Throughout the years we've had the pleasure of working with some of the most amazing brands and people."}}),_c('StartProject'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }